import React from 'react';
import { Box, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

const STATUS_META = {
  APPROVED: {
    label: 'Approved',
    color: '#4F8506',
    backgroundColor: '#EEF7E6',
    icon: 'material-symbols:check-circle-outline-rounded',
  },
  REJECTED: {
    label: 'Rejected',
    color: '#DA342E',
    backgroundColor: '#FDEDED',
    icon: 'material-symbols:cancel-outline-rounded',
  },
  PENDING: {
    label: 'Pending',
    color: '#8A5A00',
    backgroundColor: '#FFF5E1',
    icon: 'mdi:clock-outline',
  },
  ACTIVE: {
    label: 'Active',
    color: '#4F8506',
    backgroundColor: '#EEF7E6',
    icon: 'material-symbols:check-circle-outline-rounded',
  },
  INACTIVE: {
    label: 'Inactive',
    color: '#6C6A86',
    backgroundColor: '#F1F1F1',
    icon: 'material-symbols:pause-circle-outline-rounded',
  },
  DEACTIVATED: {
    label: 'Inactive',
    color: '#6C6A86',
    backgroundColor: '#F1F1F1',
    icon: 'material-symbols:pause-circle-outline-rounded',
  },
};

export function getStatusChipMeta(status) {
  const normalized = String(status || '').toUpperCase();
  return STATUS_META[normalized] || {
    label: normalized ? normalized.charAt(0) + normalized.slice(1).toLowerCase() : '-',
    color: '#6C6A86',
    backgroundColor: '#F1F1F1',
    icon: 'material-symbols:info-outline-rounded',
  };
}

export default function StatusChip({ status, size = 'regular', sx = {}, labelOverride }) {
  const meta = getStatusChipMeta(status);
  const compact = size === 'compact';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: compact ? 0.75 : 1,
        px: compact ? 1.25 : 1.5,
        height: compact ? 32 : 36,
        borderRadius: '999px',
        backgroundColor: meta.backgroundColor,
        color: meta.color,
        width: 'fit-content',
        ...sx,
      }}
    >
      <Icon icon={meta.icon} width={compact ? 16 : 18} height={compact ? 16 : 18} />
      <Typography
        sx={{
          fontSize: compact ? 14 : 16,
          lineHeight: compact ? '20px' : '24px',
          letterSpacing: compact ? '0.1px' : '0.15px',
          fontWeight: 500,
          color: 'inherit',
        }}
      >
        {labelOverride || meta.label}
      </Typography>
    </Box>
  );
}
